import { request_list, update_detail, create_detail, request_detail, remove_detail } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';
import Vue from 'vue';
const viewTitle = 'thống kê'
// initial state
const state = {
    loading: false,
    realtime_deposit: {},
    realtime_chinapay: {},
    realtime_order: {},
    commission_analytic: {
        data: [],
        total: 0,
        summary: {}
    },
    orderRevenue: [],
    realtime_service_fee: {},
    revenue_report: [],
    realtime_import: [],
    realtime_export: [],
    realtime_storage: []
};

// getters
const getters = {};

// actions
const actions = {
    getRealtimeDeposit({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('analytic/realtime-deposit', data => {
            commit('setRealtimeDeposit', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getRealtimeChinaPay({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('analytic/realtime-chinapay', data => {
            commit('setRealtimeChinaPay', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getRealtimeOrder({ commit }) {
        commit("setLoading", { loading: true });
        request_list('analytic/realtime-order', data => {
            commit('setRealtimeOrder', data);
            commit("setLoading", { loading: false });
        }, Vue.http, {}, this.state.authentication.token);
    },
    getCommissionAnalytic({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('analytic/commission', data => {
            commit('setCommissionAnalytic', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getOrderRevenue({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('analytic/orderrevenue', data => {
            commit('setOrderRevenue', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getRealtimeServiceFee({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('analytic/realtime-service-fee', data => {
            commit('setRealtimeServiceFee', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getRealtimeVNImport({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('analytic/vnimport', data => {
            commit('setRealtimeVNImport', data.data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getRealtimeVNExport({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('analytic/vnexport', data => {
            commit('setRealtimeVNExport', data.data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getRealtimeStorage({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('analytic/storage-revenue', data => {
            commit('setRealtimeStorage', data.data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getRevenueReport({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('analytic/revenue', data => {
            commit('setRevenueReport', data.data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    setRevenueReport({ commit, dispatch }, {data, id, param}) {
        update_detail('analytic/revenue', res => {
            if (res.data.status === 'fail') {
                sendErrorNotice(`Không thể cập nhật dữ liệu.`)
            }
            else {
                sendSuccessNotice(`Cập nhật dữ liệu thành công.`)
                refreshResource();
            }
        }, Vue.http, data, id, this.state.authentication.token);
    },
};

// mutations
const mutations = {
    setRealtimeDeposit(state, data) {
        state.realtime_deposit = data;
    },
    setRealtimeChinaPay(state, data) {
        state.realtime_chinapay = data;
    },
    setRealtimeOrder(state, data) {
        state.realtime_order = data;
    },
    setCommissionAnalytic(state, data) {
        state.commission_analytic = data;
    },
    setOrderRevenue(state, data) {
        state.orderRevenue = data;
    },
    setRealtimeServiceFee(state, data) {
        state.realtime_service_fee = data;
    },
    setRevenueReport(state, data) {
        state.revenue_report = data;
    },
    setRealtimeVNImport(state, data) {
        state.realtime_import = data;
    },
    setRealtimeVNExport(state, data) {
        state.realtime_export = data;
    },
    setRealtimeStorage(state, data) {
        state.realtime_storage = data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
